import { ref, Ref, inject, readonly } from 'vue';
import { DateWithZone } from '@/models/DateWithZone';

// 型定義
export interface CurrentHeaderFilter {
  organization?: string;
  appName?: string;
  startTime?: DateWithZone;
  endTime?: DateWithZone;
  relTime?: number;
}

// 初期値 (URLにパラメータがあればそれらをセットする)
const parseQueryFromWindow = () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);

  const relTime = params.get('rel_time')
    ? parseInt(params.get('rel_time') as string)
    : undefined;

  let startTime: DateWithZone | undefined;
  let endTime: DateWithZone | undefined;

  if (relTime === undefined) {
    if (params.get('end_time') || params.get('end_at')) {
      endTime = new DateWithZone(
        decodeURIComponent(
          params.get('end_time') || (params.get('end_at') as string)
        )
      );
    } else {
      const now = new DateWithZone();
      endTime = new DateWithZone(
        now.getFullYear(),
        now.getMonth() + 1,
        now.getDate(),
        23,
        59,
        0
      );
    }

    if (params.get('start_time') || params.get('start_at')) {
      startTime = new DateWithZone(
        decodeURIComponent(
          params.get('start_time') || (params.get('start_at') as string)
        )
      );
    } else {
      const raw = new DateWithZone(endTime.getTime() - 14 * 3600 * 24 * 1000);
      startTime = new DateWithZone(
        raw.getFullYear(),
        raw.getMonth() + 1,
        raw.getDate(),
        0,
        0,
        0
      );
    }
  }

  return {
    organization: params.get('organization') || undefined,
    appName: params.get('app_name') || undefined,
    service: params.get('service') || undefined,
    startTime,
    endTime,
    relTime,
  };
};

// Provider
export const createCurrentHeaderFilter = () => {
  const currentHeaderFilter: Ref<CurrentHeaderFilter> = ref(
    parseQueryFromWindow()
  );
  return {
    currentHeaderFilter,
  };
};

// Inject
export const keyCurrentHeaderFilter = Symbol();
export const useCurrentHeaderFilter = () => {
  const { currentHeaderFilter } = inject(keyCurrentHeaderFilter) as {
    currentHeaderFilter: Ref<CurrentHeaderFilter>;
  };
  const setCurrentHeaderFilter = (
    _currentHeaderFilter: CurrentHeaderFilter
  ) => {
    const tempCurrentHeaderFilter = {
      ...currentHeaderFilter.value,
      ..._currentHeaderFilter,
    };
    if (tempCurrentHeaderFilter.relTime !== undefined) {
      tempCurrentHeaderFilter.startTime = undefined;
      tempCurrentHeaderFilter.endTime = undefined;
    } else {
      if (!tempCurrentHeaderFilter.endTime) {
        tempCurrentHeaderFilter.endTime = new DateWithZone();
      }
      if (!tempCurrentHeaderFilter.startTime) {
        tempCurrentHeaderFilter.startTime = new DateWithZone(
          tempCurrentHeaderFilter.endTime.getTime() - 7 * 3600 * 24 * 1000
        );
      }
    }
    currentHeaderFilter.value = tempCurrentHeaderFilter;
  };

  return {
    currentHeaderFilter: readonly(currentHeaderFilter),
    setCurrentHeaderFilter,
  };
};
